import isUndefined from 'lodash/isUndefined';
import omitBy from 'lodash/omitBy';

import { SearchActions, SearchKeys } from './constants';
import * as D from './deps';

export function searchTermUpdate({ searchTerm, searchType, searchFilter }) {
  return {
    payload: {
      searchFilter,
      searchTerm,
      searchType,
    },
    type: D.ApiActions.T3_SEARCH_TERM_UPDATE,
  };
}

export function searchUIStateUpdate({ hasFocus, active, searchType, isFocusEvent, componentName }) {
  const content = {
    componentName,
    hasFocus,
    [SearchKeys.IS_FOCUS_EVENT]: isFocusEvent,
    [SearchKeys.SEARCH_ACTIVE]: active,
  };
  // Only pass along content without undefined values
  return {
    payload: {
      ...omitBy(content, isUndefined),
      searchType,
    },
    type: SearchActions.SEARCH_UI_UPDATE,
  };
}

export function searchItemSelect(params) {
  return {
    payload: params,
    type: SearchActions.SEARCH_SELECT,
  };
}

export function searchCleared() {
  return {
    type: SearchActions.SEARCH_CLEAR,
  };
}

export function searchResultsScroll(params) {
  return {
    payload: params,
    type: SearchActions.SEARCH_SCROLL,
  };
}

export const searchResultsRendered = params => ({
  payload: params,
  type: SearchActions.SEARCH_RESULTS_RENDERED,
});

export function fullSearch({
  searchTerm,
  searchFilter = 'all',
  searchType,
  startIndex = 0,
  pageSize = 50,
  searchTime = 0,
}) {
  return {
    payload: {
      count: pageSize,
      searchFilter,
      searchTerm,
      searchTime,
      searchType,
      start: startIndex,
    },
    type: SearchActions.FULL_SEARCH,
  };
}

export function resetResults() {
  return {
    type: SearchActions.RESET_RESULTS,
  };
}

export function filterChanged({ searchTerm, searchFilter, results }) {
  return {
    payload: {
      results,
      searchFilter,
      searchTerm,
    },
    type: SearchActions.FILTER_CHANGED,
  };
}

export function closeSearch() {
  return {
    type: SearchActions.CLOSE_SEARCH,
  };
}
